import { each } from '@antv/util';
import MaskBase from './base';

/**
 * @ignore
 * å¤ä¸ªç¹ææç Path è¾å©æ¡ Action
 */
class PathMask extends MaskBase {
  // çæ mask çè·¯å¾
  protected getMaskPath() {
    const points = this.points;
    const path = [];
    if (points.length) {
      each(points, (point, index) => {
        if (index === 0) {
          path.push(['M', point.x, point.y]);
        } else {
          path.push(['L', point.x, point.y]);
        }
      });
      path.push(['L', points[0].x, points[0].y]);
    }
    return path;
  }

  protected getMaskAttrs() {
    return {
      path: this.getMaskPath(),
    };
  }

  /**
   * æ·»å ä¸ä¸ªç¹
   */
  public addPoint() {
    this.resize();
  }
}

export default PathMask;
